import clickOutside from 'click-outside/index'

export default function toggleHtmlClassOnClick(page) {
  page.querySelectorAll('[data-toggle-on-click]').forEach(el => {
    const { toggleOnClick } = el.dataset
    const outsideClick = Array.from(
      page.querySelectorAll('[data-outside-click]')
    ).filter(item => item.dataset.outsideClick === toggleOnClick)

    el.addEventListener('click', () => {
      document.documentElement.classList.toggle(
        toggleOnClick,
        !document.documentElement.classList.contains(toggleOnClick)
      )
    })

    clickOutside(el, e => {
      if (!outsideClick.some(item => item === e.target)) {
        document.documentElement.classList.remove(toggleOnClick)
      }
    })
  })
}
